export const SECRET_GRADE_COLORS = {
  C1: 'green',
  C2: 'blue',
  C3: 'orange',
  C4: 'red'
}

export const BPM_STATUS = {
  0: '审批中',
  1: '审批通过',
  2: '审批未通过',
  6: '关闭'
}

export const BPM_TYPE = {
  'LEAVE': '待离职人员审批',
  'MAX_ROW': '大文件下载审批'
}
